import cn from 'classnames';
import { useQueryOrder } from 'hooks/routes';
import { SortIcon_16 } from 'assets/icons';
import styles from './TableSorting.module.css';

type Props = {
  sortingFieldKey: string;
  sortingFieldName: string;
};

const TableSorting = ({ sortingFieldKey, sortingFieldName }: Props): JSX.Element => {
  const [orderByName, setOrderByName] = useQueryOrder();
  const isActiveSorting = !!orderByName && orderByName[0] === sortingFieldKey;
  const onChangeOrder = () => {
    orderByName && orderByName[1] === 'desc'
      ? setOrderByName([sortingFieldKey, 'asc'])
      : setOrderByName([sortingFieldKey, 'desc']);
  };

  return (
    <span className={styles.tableSorting__sortCell}>
      {sortingFieldName}
      <SortIcon_16
        className={cn(
          styles.tableSorting__sortIcon,
          isActiveSorting &&
            styles[`tableSorting__sortIcon_${orderByName ? orderByName[1] : 'asc'}`],
        )}
        onClick={onChangeOrder}
      />
    </span>
  );
};

export default TableSorting;
